module.exports = __webpack_public_path__ + "img/certificate.3facc223.png";